import { apiSlice } from 'store/slices/api/api-slice';
import { PresentUserRequest } from 'types/presen-user/present-user';

export const presentCardApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        presentCard: builder.mutation<void, PresentUserRequest>({
            query: (presentUserRequest: PresentUserRequest) => ({
                url: `system-present/admin/system-present`,
                method: 'POST',
                body: presentUserRequest,
            }),
        }),
    }),
});

export const { usePresentCardMutation } = presentCardApi;
